"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoMotorplanOptionalContractComponent = void 0;
var core_1 = require("@angular/core");
var fileSaver = require("file-saver");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var _services_1 = require("@/_services");
var vehicle_motorplan_service_1 = require("@/_services/vehicle-motorplan.service");
var storage_service_1 = require("@/_services/storage-service");
var NoMotorplanOptionalContractComponent = /** @class */ (function () {
    function NoMotorplanOptionalContractComponent(authenticationService, modalService, vehicleMotorplanService, storageService) {
        this.authenticationService = authenticationService;
        this.modalService = modalService;
        this.vehicleMotorplanService = vehicleMotorplanService;
        this.storageService = storageService;
        this.showMotorPlanOptional = false;
        this.onChange = function (event) {
            this.contractTypeSelected = event.target.value;
        };
        this.showMotorPlanOptional = false;
    }
    NoMotorplanOptionalContractComponent.prototype.saveFile = function (data, filename) {
        var blob = new Blob([data], { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, filename);
    };
    NoMotorplanOptionalContractComponent.prototype.ngOnInit = function () {
        this.get_gcdm_config = this.authenticationService.get_config();
        this.loginBrand = this.get_gcdm_config['brand'];
        this.showMotorPlanOptional = false;
    };
    // redirectToMotorPlanOptionalApp(){
    //     let vehicleMotorplanServiceObservable = this.vehicleMotorplanService.postToOptionalContractApp(this.contractTypeSelected, this.vin, this.storageService.getDealerId());
    //     vehicleMotorplanServiceObservable.subscribe((transactToMotorPlanApp: any) => {transactToMotorPlanApp; 
    //     if(transactToMotorPlanApp){
    //         // const url = this.get_gcdm_config['ON_CALL_hostname'];
    //         // window.open(url+transactToMotorPlanApp.transactionId, '_blank');
    //         console.log("transactToMotorPlanApp.transactionId ::: ",transactToMotorPlanApp.transactionId);
    //     }
    //   });
    // }
    NoMotorplanOptionalContractComponent.prototype.getDismissReason = function (reason) {
        if (reason === ng_bootstrap_1.ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        }
        else if (reason === ng_bootstrap_1.ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
        else {
            return "with: " + reason;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NoMotorplanOptionalContractComponent.prototype, "childMotorPlanOpationals", void 0);
    NoMotorplanOptionalContractComponent = __decorate([
        core_1.Component({
            selector: 'motorplan-optional-contract',
            template: require('./motorplanoptionalcontract.component.html')
        }),
        __metadata("design:paramtypes", [_services_1.AuthenticationService,
            ng_bootstrap_1.NgbModal, vehicle_motorplan_service_1.VehicleMotorplanService,
            storage_service_1.StorageService])
    ], NoMotorplanOptionalContractComponent);
    return NoMotorplanOptionalContractComponent;
}());
exports.NoMotorplanOptionalContractComponent = NoMotorplanOptionalContractComponent;
